export const addQueryParams = (params: Record<string, string | number | boolean | null>, replace = true): void => {
  const url = new URL(window.location.href);
  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      url.searchParams.delete(key); // remove param if null
    } else {
      url.searchParams.set(key, String(value));
    }
  });

  const newUrl = url.toString();

  if (replace) {
    history.replaceState(null, '', newUrl);
  } else {
    history.pushState(null, '', newUrl);
  }
};

export const getQueryParams = (keys: string[]): Record<string, string | undefined> => {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string | undefined> = {};

  keys.forEach((key) => {
    const value = params.get(key);
    if (value) {
      result[key] = value;
    }
  });

  return result;
};

export const removeIdFromBrandUrl = (url: string): string => {
  const urlObj = new URL(url);
  const pathname = urlObj.pathname.replace(/\/[^/]+$/, '/brand');
  return `${urlObj.origin}${pathname}${urlObj.search}`;
};

export const removeIdFromUrl = (url: string, keepParams?: string[]): string => {
  const urlObj = new URL(url);
  const pathname = urlObj.pathname.replace(/\/[^/]+$/, '');
  let params: URLSearchParams;
  if (!keepParams || keepParams?.length === 0) {
    params = new URLSearchParams(urlObj.search);
  } else {
    params = new URLSearchParams();
    keepParams.forEach((key) => {
      const value = urlObj.searchParams.get(key);
      if (value !== null) {
        params.set(key, value);
      }
    });
  }

  const search = params.toString();
  return `${urlObj.origin}${pathname}${search ? `?${search}` : ''}`;
};

export const updateIdForSearchPage = (url: string): string => {
  const arr = url.split('/');
  const q = arr[arr.length - 1];
  const newUrl = removeIdFromUrl(url);
  const urlObj = new URL(newUrl);
  urlObj.searchParams.set('q', q);
  return urlObj.toString();
};
